export default {
  ADD_ART: 'analytics/ADD_ART',
  AD_ACCEPT: 'analytics/AD_ACCEPT',
  ART_BROWSE: 'analytics/ART_BROWSE',
  AD_ART_SWAP: 'analytics/AD_ART_SWAP',
  AD_EDIT_MESSAGE: 'analytics/AD_EDIT_MESSAGE',
  AD_ENTRY_DECISION: 'analytics/AD_ENTRY_DECISION',
  AD_LAYOUTS: 'analytics/AD_LAYOUTS',
  AD_NO_TEXT: 'analytics/AD_NO_TEXT',
  AD_DESKTOP_PROMO: 'analytics/AD_DESKTOP_PROMO',
  AD_DESKTOP_SELECT: 'analytics/AD_DESKTOP_SELECT',
  AD_SKIP_TEXT: 'analytics/AD_SKIP_TEXT',
  ADD_COMPLEMENT: 'analytics/ADD_COMPLEMENT',
  ADD_DESIGN: 'analytics/ADD_DESIGN',
  ADD_ITEMS: 'analytics/ADD_ITEMS',
  ADD_ITEMS_CLOSE: 'analytics/ADD_ITEMS_CLOSE',
  ADD_ITEMS_COLOR_CLOSE: 'analytics/ADD_ITEMS_COLOR_CLOSE',
  ADD_ITEMS_COLOR: 'analytics/ADD_ITEMS_COLOR',
  ADD_ITEMS_PICK_STYLE: 'analytics/ADD_ITEMS_PICK_STYLE',
  ADD_ITEMS_QUOTE: 'analytics/ADD_ITEMS_QUOTE',
  ADD_ITEMS_SELECT_COLOR: 'analytics/ADD_ITEMS_SELECT_COLOR',
  ADD_ITEMS_BROWSE_MORE: 'analytics/ADD_ITEMS_BROWSE_MORE',
  ADD_TEXT: 'analytics/ADD_TEXT',
  ART_CLOSE: 'analytics/ART_CLOSE',
  ART_PALETTE: 'analytics/ART_PALETTE',
  ART_SWAP: 'analytics/ART_SWAP',
  ART_COLORS: 'analytics/ART_COLORS',
  ART_CHANGE_COLOR: 'analytics/ART_CHANGE_COLOR',
  ART_RESET_COLOR: 'analytics/ART_RESET_COLOR',
  ALIGN_MENU: 'analytics/ALIGN_MENU',
  ART_TOOLS: 'analytics/ART_TOOLS',
  BUY_FORM: 'analytics/BUY_FORM',
  BUY_NOW_CTA_TEST: 'analytics/BUY_NOW_CTA_TEST',
  BUY_WITH_GOF: 'analytics/BUY_WITH_GOF',
  BUY_WITH_GOF_QUOTE_START: 'analytics/BUY_WITH_GOF_QUOTE_START',
  BUY_WITH_GOF_QUOTE_COMPLETE: 'analytics/BUY_WITH_GOF_QUOTE_COMPLETE',
  CANCEL_AD_LEAVE: 'analytics/CANCEL_AD_LEAVE',
  CHANGE_PRODUCT_COLOR_START: 'analytics/CHANGE_PRODUCT_COLOR_START',
  CHANGE_PRODUCT_START: 'analytics/CHANGE_PRODUCT_START',
  CHANGE_TEXT_EFFECT: 'analytics/CHANGE_TEXT_EFFECT',
  CHANGE_TEXT_OUTLINE: 'analytics/CHANGE_TEXT_OUTLINE',
  CHANGE_TEXT_OUTLINE_COMPLETE: 'analytics/CHANGE_TEXT_OUTLINE_COMPLETE',
  CHAT: 'analytics/CHAT',
  COLOR_CTA_CLICK: 'analytics/COLOR_CTA_CLICK',
  CURRENT_PATH_PAGE_VIEW_TAG: 'analytics/CURRENT_PATH_PAGE_VIEW_TAG',
  DEFAULT_BLANK_TEST: 'analytics/DEFAULT_BLANK_TEST',
  DESIGN_TOOLS_OPEN: 'analytics/DESIGN_TOOLS_OPEN',
  DESIGN_TOOLS_SELECT: 'analytics/DESIGN_TOOLS_SELECT',
  DESIGN_TOOLS_CLOSE: 'analytics/DESIGN_TOOLS_CLOSE',
  DESIGN_WITH_PRO: 'analytics/DESIGN_WITH_PRO',
  DISCONTINUED_PRODUCT: 'analytics/DISCONTINUED_PRODUCT',
  DISCONTINUED_PRODUCT_COLOR: 'analytics/DISCONTINUED_PRODUCT_COLOR',
  ENTER_POSTAL_CODE: 'analytics/ENTER_POSTAL_CODE',
  EMBROIDERY_MODAL_TEST: 'analytics/EMBROIDERY_MODAL_TEST',
  FONT_BROWSE_SEE_MORE: 'analytics/FONT_BROWSE_SEE_MORE',
  FUNDRAISING_NAVIGATION: 'analytics/FUNDRAISING_NAVIGATION',
  FUNDRAISING_CAMPAIGN_CLOSED: 'analytics/FUNDRAISING_CAMPAIGN_CLOSED',
  FUNDRAISING_MODE_WELCOME: 'analytics/FUNDRAISING_MODE_WELCOME',
  FUNDRAISING_MODE_GOALS: 'analytics/FUNDRAISING_MODE_GOALS',
  HELP_CALL: 'analytics/HELP_CALL',
  HELP_EMAIL: 'analytics/HELP_EMAIL',
  HELP_FEEDBACK: 'analytics/HELP_FEEDBACK',
  HELP_MENU: 'analytics/HELP_MENU',
  HELP_VISIT_FULL_SITE: 'analytics/HELP_VISIT_FULL_SITE',
  HIDE_CONTEXTUAL_TOOLS: 'analytics/HIDE_CONTEXTUAL_TOOLS',
  LAB_FROM_AD: 'analytics/LAB_FROM_AD',
  LOAD_WITHOUT_DESIGN: 'analytics/LOAD_WITHOUT_DESIGN',
  ORDER_MORE: 'analytics/ORDER_MORE',
  ORDER_MORE_ADD_STYLES: 'analytics/ORDER_MORE_ADD_STYLES',
  ORDER_MORE_ADD_ITEMS_ADD_STYLES: 'analytics/ORDER_MORE_ADD_ITEMS_ADD_STYLES',
  ORDER_MORE_STYLES_ADDED: 'analytics/ORDER_MORE_STYLES_ADDED',
  ORDER_MORE_QUOTE_ADD_STYLES: 'analytics/ORDER_MORE_QUOTE_ADD_STYLES',
  NAMES_AND_NUMBERS: 'analytics/NAMES_AND_NUMBERS',
  NAMES_AND_NUMBERS_COLORS: 'analytics/NAMES_AND_NUMBERS_COLORS',
  NAMES_AND_NUMBERS_CLOSE: 'analytics/NAMES_AND_NUMBERS_CLOSE',
  NAMES_AND_NUMBERS_GET_STARTED: 'analytics/NAMES_AND_NUMBERS_GET_STARTED',
  NAMES_AND_NUMBERS_POSITION: 'analytics/NAMES_AND_NUMBERS_POSITION',
  NAMES_AND_NUMBERS_REDIRECT: 'analytics/NAMES_AND_NUMBERS_REDIRECT',
  NAMES_AND_NUMBERS_LIST: 'analytics/NAMES_AND_NUMBERS_LIST',
  NAMES_AND_NUMBERS_ALERT: 'analytics/NAMES_AND_NUMBERS_ALERT',
  NAMES_AND_NUMBERS_COMPLETE: 'analytics/NAMES_AND_NUMBERS_COMPLETE',
  NAMES_AND_NUMBERS_EDIT: 'analytics/NAMES_AND_NUMBERS_EDIT',
  NDX_BREAKPOINT: 'analytics/NDX_BREAKPOINT',
  NDX_START: 'analytics/NDX_START',
  NEXT_GOF: 'analytics/NEXT_GOF',
  NEXT_FULL: 'analytics/NEXT_FULL',
  NEXT_FUNDRAISING: 'analytics/NEXT_FUNDRAISING',
  NEXT_FUNDRAISING_GOALS: 'analytics/NEXT_FUNDRAISING_GOALS',
  NEXT: 'analytics/NEXT',
  PRINT_THIS: 'analytics/PRINT_THIS',
  PRO_GATE: 'analytics/PRO_GATE',
  PRODUCT_COLOR_CHANGE_ACCEPTED: 'analytics/PRODUCT_COLOR_CHANGE_ACCEPTED',
  PRODUCT_COLOR_CHANGE_CANCELLED: 'analytics/PRODUCT_COLOR_CHANGE_CANCELLED',
  PRODUCT_COLOR_CHANGED: 'analytics/PRODUCT_COLOR_CHANGED',
  PRODUCT_COLOR_NOT_CHANGED: 'analytics/PRODUCT_COLOR_NOT_CHANGED',
  PRODUCT_COLOR_TAB_CHANGED: 'analytics/PRODUCT_COLOR_TAB_CHANGED',
  PRODUCT_COLOR_TOGGLE_CHANGED: 'analytics/PRODUCT_COLOR_TOGGLE_CHANGED',
  PRODUCT_COLOR: 'analytics/PRODUCT_COLOR',
  PRODUCT_CATALOG: 'analytics/PRODUCT_CATALOG',
  PRODUCT_DETAILS: 'analytics/PRODUCT_DETAILS',
  PRODUCT_PRINT_AREA: 'analytics/PRODUCT_PRINT_AREA',
  PRODUCT_SUMMARY: 'analytics/PRODUCT_SUMMARY',
  PRODUCT_SUMMARY_CAROUSEL: 'analytics/PRODUCT_SUMMARY_CAROUSEL',
  PRODUCT_SUMMARY_TAG: 'analytics/PRODUCT_SUMMARY_TAG',
  PRODUCT_WELCOME: 'analytics/PRODUCT_WELCOME',
  QUOTE_BLANK_DESIGN: 'analytics/QUOTE_BLANK_DESIGN',
  QUOTE_FORM: 'analytics/QUOTE_FORM',
  QUOTE_FORM_POSTAL_CODE_CHANGE: 'analytics/QUOTE_FORM_POSTAL_CODE_CHANGE',
  QUOTE_FORM_START: 'analytics/QUOTE_FORM_START',
  QUOTE_STATE_CHANGE: 'analytics/QUOTE_STATE_CHANGE',
  QUOTE_WCIBMO: 'analytics/QUOTE_WCIBMO',
  REAL_TIME_PRICE_CHANGE: 'analytics/REAL_TIME_PRICE_CHANGE',
  REAL_TIME_PRICE_QUANTITY_CHANGE: 'analytics/REAL_TIME_PRICE_QUANTITY_CHANGE',
  REAL_TIME_PRICING_TEST: 'analytics/REAL_TIME_PRICING_TEST',
  RESIZE: 'analytics/RESIZE',
  SAVE_FORM: 'analytics/SAVE_FORM',
  SAVE_ADD_CART_ATTEMPT: 'analytics/SAVE_ADD_CART_ATTEMPT',
  SAVE_ADD_CART: 'analytics/SAVE_ADD_CART',
  SELECT_FONT: 'analytics/SELECT_FONT',
  SHARE_FACEBOOK: 'analytics/SHARE_FACEBOOK',
  SHARE_EMAIL: 'analytics/SHARE_EMAIL',
  SHARE_LINK: 'analytics/SHARE_LINK',
  SHARE_PINTEREST: 'analytics/SHARE_PINTEREST',
  SHARE_TWITTER: 'analytics/SHARE_TWITTER',
  SHOPPING_CART_CANCEL: 'analytics/SHOPPING_CART_CANCEL',
  SHOPPING_CART_STATUS: 'analytics/SHOPPING_CART_STATUS',
  SINGLES_TOGGLE_TEST: 'analytics/SINGLES_TOGGLE_TEST',
  SLEEVE_ERROR_FUNDRAISING: 'analytics/SLEEVE_ERROR_FUNDRAISING',
  SLEEVE_ERROR_GOF: 'analytics/SLEEVE_ERROR_GOF',
  STRIKE_PRICING: 'analytics/STRIKE_PRICING',
  SINGLES_CONTENT_ALERT_TEST: 'analytics/SINGLES_CONTENT_ALERT_TEST',
  SINGLES_PRICING_MESSAGE_TEST: 'analytics/SINGLES_PRICING_MESSAGE_TEST',
  SLEEVE_PRINT: 'analytics/SLEEVE_PRINT',
  SLEEVE_PRINT_ACTIONS: 'analytics/SLEEVE_PRINT_ACTIONS',
  SLEEVE_PRINT_MODAL: 'analytics/SLEEVE_PRINT_MODAL',
  SLEEVE_PRINT_NO_SLEEVE_IMAGE_SELECTED_PRODUCT:
    'analytics/SLEEVE_PRINT_NO_SLEEVE_IMAGE_SELECTED_PRODUCT',
  SLEEVE_PRINT_PRICE_INFO: 'analytics/SLEEVE_PRINT_PRICE_INFO',
  SLEEVE_PRINT_REMOVE_DESIGN: 'analytics/SLEEVE_PRINT_REMOVE_DESIGN',
  SLEEVE_PRINT_UNDO_REMOVE_DESIGN: 'analytics/SLEEVE_PRINT_UNDO_REMOVE_DESIGN',
  START_POSTAL_CODE_UPDATE: 'analytics/START_POSTAL_CODE_UPDATE',
  SUBTLETY_CHECK: 'analytics/SUBTLETY_CHECK',
  SUPPRESS_EMAIL_VALIDATION: 'analytics/SUPPRESS_EMAIL_VALIDATION',
  SWAP_PRODUCT_WARNING: 'analytics/SWAP_PRODUCT_WARNING',
  TEST_INTO_DECO_FLEX: 'analytics/TEST_INTO_DECO_FLEX',
  TEXT_EDIT: 'analytics/TEXT_EDIT',
  TEXT_EFFECTS_BROWSE: 'analytics/TEXT_EFFECTS_BROWSE',
  TEXT_EFFECT_DONE: 'analytics/TEXT_EFFECT_DONE',
  TEXT_EFFECT_INTENSITY: 'analytics/TEXT_EFFECT_INTENSITY',
  TEXT_FONT_BROWSE: 'analytics/TEXT_FONT_BROWSE',
  TEXT_FONT_BROWSE_CATEGORIES: 'analytics/TEXT_FONT_BROWSE_CATEGORIES',
  TEXT_OUTLINE_INTENSITY: 'analytics/TEXT_OUTLINE_INTENSITY',
  TEXT_OUTLINE_COLOR: 'analytics/TEXT_OUTLINE_COLOR',
  TEXT_OUTLINE_ON: 'analytics/TEXT_OUTLINE_ON',
  TEXT_OUTLINE_OFF: 'analytics/TEXT_OUTLINE_OFF',
  TEXT_PALETTE: 'analytics/TEXT_PALETTE',
  TEXT_START: 'analytics/TEXT_START',
  TEXT_SEARCH: 'analytics/TEXT_SEARCH',
  TEXT_TOOLS: 'analytics/TEXT_TOOLS',
  UPDATE_EXTERNAL_EVENT: 'analytics/UPDATE_EXTERNAL_EVENT',
  UPLOAD: 'analytics/UPLOAD',
  UPLOAD_ADD: 'analytics/UPLOAD_ADD',
  UPLOAD_START: 'analytics/UPLOAD_START',
  UPLOAD_BROWSE: 'analytics/UPLOAD_BROWSE',
  UPLOAD_CHANGE_COLOR: 'analytics/UPLOAD_CHANGE_COLOR',
  UPLOAD_CLOSE_TOOLS: 'analytics/UPLOAD_CLOSE_TOOLS',
  UPLOAD_CONTACT_US: 'analytics/UPLOAD_CONTACT_US',
  UPLOAD_DRAG: 'analytics/UPLOAD_DRAG',
  UPLOAD_COLOR_REMOVAL: 'analytics/UPLOAD_COLOR_REMOVAL',
  UPLOAD_LEARN_MORE: 'analytics/UPLOAD_LEARN_MORE',
  UPLOAD_RECENT: 'analytics/UPLOAD_RECENT',
  UPLOAD_RESET_COLOR: 'analytics/UPLOAD_RESET_COLOR',
  UPLOAD_SUCCESS: 'analytics/UPLOAD_SUCCESS',
  UPLOAD_TOGGLE_BACKGROUND: 'analytics/UPLOAD_TOGGLE_BACKGROUND',
  UPLOAD_TOGGLE_PRODUCT_COLOR: 'analytics/UPLOAD_TOGGLE_PRODUCT_COLOR',
  UPLOAD_TOOLS: 'analytics/UPLOAD_TOOLS',
  UPLOAD_OR_BROWSE_ART: 'analytics/UPLOAD_OR_BROWSE_ART',
  VIEW_ALL_FONT_CATEGORIES: 'analytics/VIEW_ALL_FONT_CATEGORIES',
  WTO_OPTION_LOAD: 'analytics/WTO_OPTION_LOAD',
  WTO_OPTION_CONFIRM_BULK: 'analytics/WTO_OPTION_CONFIRM_BULK',
  WTO_OPTION_UPDATE: 'analytics/WTO_OPTION_UPDATE',
  WELCOME: 'analytics/WELCOME',
  WELCOME_BACK_CONTINUE: 'analytics/WELCOME_BACK_CONTINUE',
  WELCOME_BACK_NEW: 'analytics/WELCOME_BACK_NEW',
  WELCOME_BACK: 'analytics/WELCOME_BACK',
  ZOOM_IN: 'analytics/ZOOM_IN',
  ZOOM_OUT: 'analytics/ZOOM_OUT'
};
